import { PostHogProvider } from "@posthog/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { CommandCenter } from "@/components/command-center";
import { ThemeProvider } from "@/components/theme-provider";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/auth-context";
import { ToastProvider } from "@/context/toast-context";
import Routes from "@/routes";

import { RechargeDialog } from "./components/wallet/dialogs/recharge-dialog";

export const queryClient = new QueryClient();

const options = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  defaults: "2026-01-30",
} as const;

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ToastProvider>
          <ThemeProvider>
            <PostHogProvider
              apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
              options={options}
            >
              <Routes />
              <CommandCenter />
              <RechargeDialog />
            </PostHogProvider>
          </ThemeProvider>
        </ToastProvider>
      </AuthProvider>

      <Toaster />
    </QueryClientProvider>
  );
}

export default App;
